module.exports = __webpack_public_path__ + "img/0.5ec6322c.png";